import { useEffect, useState } from "react";
import { useI18n } from "@/i18n";
import { loungeCopy } from "@/lib/loungeCopy";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import logoPng from "@/assets/brema-logo.png";

export default function PressConfirm() {
  const { lang } = useI18n();
  const c = loungeCopy(lang);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    document.title = "Brema 1969 · Press";
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) { setStatus("err"); return; }
    api.post("/public/lounge/press-confirm", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("err"));
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-5 py-16 text-foreground" data-testid="press-confirm-page">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center">
        <img src={logoPng} alt="Brema 1969" className="mx-auto mb-7 h-9 w-auto dark:brightness-0 dark:invert" />
        {status === "loading" && (
          <div className="flex flex-col items-center gap-3 text-muted-foreground" data-testid="press-confirm-loading">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <p>{c.confirm_loading}</p>
          </div>
        )}
        {status === "ok" && (
          <div className="flex flex-col items-center gap-3" data-testid="press-confirm-ok">
            <CheckCircle2 className="h-12 w-12 text-emerald-500" />
            <h1 className="text-xl font-bold">{c.confirm_ok}</h1>
            <p className="text-sm text-muted-foreground">{c.confirm_ok_desc}</p>
          </div>
        )}
        {status === "err" && (
          <div className="flex flex-col items-center gap-3" data-testid="press-confirm-err">
            <XCircle className="h-12 w-12 text-destructive" />
            <h1 className="text-xl font-bold">{c.confirm_title}</h1>
            <p className="text-sm text-muted-foreground">{c.confirm_err}</p>
          </div>
        )}
        <Button asChild className="mt-7 rounded-full bg-primary font-semibold text-primary-foreground hover:bg-primary/90" data-testid="press-confirm-cta">
          <a href="/press-lounge">{c.confirm_cta}</a>
        </Button>
      </div>
    </div>
  );
}
